<template>
  <div class="">
    <div class="flex-y-center justify-between">
      <h2
        class="font-interDisplay text-2xl lg:text-[32px] font-semibold leading-130"
      >
        {{ title }}
      </h2>
      <slot name="suffix" />
    </div>
    <hr class="w-full h-px bg-gray-250 my-5" />
    <div
      :class="bg"
      class="relative w-full h-[160px] md:h-[280px] rounded-xl mb-4 lg:mb-10 flex items-start justify-end overflow-hidden"
    >
      <img class="align-top w-full lg:w-[700px]" :src="cover" alt="Profile" />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string;
  cover: string;
  bg: string;
}
defineProps<Props>();
</script>

<style scoped></style>
